export enum EvTruck {
  IntroShown = 'intro_shown',
  IntroSuccess = 'intro_success',
  EmailSuccess = 'email_success',
  SubscriptionShown = 'subscription_shown',
  ModalPaymentShown = 'modal_payment_shown',
  CardSubmit = 'card_submit',
  ApplePaySubmit = 'apple_pay_submit',
  ModalPaymentSubmit = 'modal_payment_submit',
  Purchase = 'ecommerce_purchase',
  PurchaseError = 'ecommerce_purchase_error',
  AdditionalPurchase = 'ecommerce_additional_purchase',
  AdditionalPurchaseError = 'ecommerce_additional_purchase_error',
  OffersShown = 'offers_shown',
  AccountScreenShown = 'account_product_shown',
  ResultsScreenShown = 'results_product_shown',
  OnboardingShown = 'onboarding_shown',
  SelfieShown = 'selfie_shown',
  SelfieProcessing = 'selfie_processing_shown',
  EmailScreenShown = 'email_screen_shown',
  QuizShown = 'quiz_shown',
  PhotolabOnboardingShown = 'photolab_onboarding_shown',
  PhotolabSkipSubScreenShown = 'photolab_skip_sub_screen_shown',
  PhotolabRestoreSubScreenShown = 'photolab_restore_sub_screen_shown',
  PhotolabRestoreOffersShown = 'photolab_restore_offers_shown',
  PhotolabSkipOffersShown = 'photolab_skip_offers_shown',
  PhotolabRestoreSignIn = 'photolab_restore_sign_in',
  PhotolabSkipSignIn = 'photolab_skip_sign_in',
}
